import React from 'react';

import { ErrorAlert } from 'components/ErrorAlert';
import { GuestSmartAssistantAccessibilityGuard } from 'pages/GuestSmartAssistant/components/GuestSmartAssistantAccessibilityGuard';
import { GuestSmartAssistantDataValidationGuard } from 'pages/GuestSmartAssistant/components/GuestSmartAssistantDataValidationGuard';
import { GuestTextBasedSmartAssistantPage } from 'pages/GuestSmartAssistant/TextBasedSmartAssistant/GuestTextBasedSmartAssistantPage';
import { GuestVoiceBasedSmartAssistantPage } from 'pages/GuestSmartAssistant/VoiceBasedSmartAssistant/GuestVoiceBasedSmartAssistantPage';
import { useParams } from 'react-router';
import { SmartAssistantType } from 'shared/interfaces/SmartAssistant';

const VOICE_BASED_SMART_ASSISTANT_TYPES = [SmartAssistantType.PHONE];
const TEXT_BASED_SMART_ASSISTANT_TYPES = Object.values(SmartAssistantType).filter(
  (type) => !VOICE_BASED_SMART_ASSISTANT_TYPES.includes(type)
);

export function GuestSmartAssistantPage() {
  const { smartAssistantId } = useParams();

  return (
    <GuestSmartAssistantAccessibilityGuard smartAssistantId={smartAssistantId}>
      {smartAssistantId && (
        <GuestSmartAssistantDataValidationGuard smartAssistantId={smartAssistantId}>
          {(guestSmartAssistantData, avatarUrl) => {
            const type = guestSmartAssistantData.smartAssistant.type;
            if (TEXT_BASED_SMART_ASSISTANT_TYPES.includes(type)) {
              return (
                <GuestTextBasedSmartAssistantPage
                  guestSmartAssistantData={guestSmartAssistantData}
                  avatarUrl={avatarUrl}
                />
              );
            }
            if (VOICE_BASED_SMART_ASSISTANT_TYPES.includes(type)) {
              return (
                <GuestVoiceBasedSmartAssistantPage
                  guestSmartAssistantData={guestSmartAssistantData}
                  avatarUrl={avatarUrl}
                />
              );
            }
            // fallback for unsupported types
            return <ErrorAlert w="100svw" h="100svh" />;
          }}
        </GuestSmartAssistantDataValidationGuard>
      )}
    </GuestSmartAssistantAccessibilityGuard>
  );
}
